import { complianceService } from './complianceService';

export default complianceService;
